import { render, staticRenderFns } from "./AccountantsTotalsList.vue?vue&type=template&id=cdc5aed0"
import script from "./AccountantsTotalsList.vue?vue&type=script&lang=js"
export * from "./AccountantsTotalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports